module.exports = __webpack_public_path__ + "static/media/big-header.8aa2def7.svg";